module.exports = __webpack_public_path__ + "img/pr-22.77ec33d3.png";